<div class="grid" id="grid">
  <div class="col-12">
    <div class="grid">
      <div class="flex flex-column col-12">
        <div class="card">
          <div class="p-datatable p-component p-datatable-hoverable-rows">
            <div class="flex align-items-center justify-content-end">
              <div>
                <button
                  [disabled]="!dataLoaded"
                  [label]="'common.exportXls' | transloco"
                  (click)="exportVisible = !exportVisible; chartMode = false"
                  pButton
                  class="p-button-secondary md:mr-2"
                  icon="pi pi-file-excel"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-column col-12">
        <div class="card relative">
          <div class="absolute top-0 left-0" pTooltip="{{'misc.info.analysis.totalConsumption' | transloco}}"
               tooltipPosition="top">
            <div class="info-background">
              <i class="pi pi-info" style="font-size: 0.8rem"></i>
            </div>
          </div>
          <div class="card-header pt-1">
            <h4 class="mb-1">{{'misc.overview.totalConsumption' | transloco}}</h4>
          </div>
          <hr>
          <div class="flex h-4rem" *ngIf="this.dataLoaded">
            <span class="m-auto text-400 font-medium text-xl"
              *ngIf="this.totalSqueezedFruits == null || this.totalSqueezedFruits == undefined">
              {{'empty.measures' | transloco}}</span>
            <h4 *ngIf="this.totalSqueezedFruits != null && this.totalSqueezedFruits != undefined"
              class="text-center text-primary font-semibold m-auto py-2">
              {{totalSqueezedFruits | number: '' : this.language}}&nbsp;{{'misc.overview.squeezedFruits' | transloco}}
            </h4>
          </div>
          <div class="h-4rem" *ngIf="!this.dataLoaded">
            <p-skeleton class="m-auto" width="100%" height="3.5rem"></p-skeleton>
          </div>
        </div>
        <div class="card relative">
          <div class="absolute top-0 left-0" pTooltip="{{'misc.info.analysis.top10Machines' | transloco}}"
               tooltipPosition="top">
            <div class="info-background">
              <i class="pi pi-info" style="font-size: 0.8rem"></i>
            </div>
          </div>
          <div class="card-header pt-1">
            <div class="mb-1 flex justify-content-between w-full">
              <h4 class="mb-0 line-height-3">{{'misc.overview.top10Machines' | transloco}} -
                {{'misc.overview.totalSqueezedFruitsCounter' | transloco}}</h4>
              <p-selectButton [options]="this.dataModeOptions" [(ngModel)]="this.chartMode" optionLabel="name"
                              optionValue="code"></p-selectButton>
            </div>
          </div>
          <hr>
          <ng-container *ngIf="this.chartMode">
            <app-generic-graph
              *ngIf="this.dataLoaded"
              [data]="totalSqueezedFruitsGraphData"
              [categories]="serialNumbersAndAlias"
              [dataType]="'category'"
              [customSeries]="true"
              [legend]="false"
              [plotOptions]="plotOptions"
              [pointFormat]="pointFormat"
              [height]="350"
              name="Value"
              #topMachinesChart>
            </app-generic-graph>
          </ng-container>
          <ng-container *ngIf="!this.chartMode">
            <p-table [value]="totalSqueezedFruitsTableData" [rows]="10">
              <ng-template pTemplate="header">
                <tr>
                  <th scope="col">
                    {{'attribute.serialNumber' | transloco}}
                  </th>
                  <th scope="col">
                    {{'attribute.alias' | transloco}}
                  </th>
                  <th scope="col">
                    {{'model.organization' | transloco}}
                  </th>
                  <th scope="col">
                    {{'attribute.squeezedFruits' | transloco}}
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-machine>
                <tr *ngIf="dataLoaded">
                  <td>
                    <span class="p-column-title bold">{{'model.machine' | transloco}}</span>
                    {{machine.serial}}
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.alias' | transloco}}</span>
                    {{machine.alias}}
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'model.organization' | transloco}}</span>
                    {{machine.organization.name}} ({{machine.organization.orgCode}})
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.squeezedFruits' | transloco}}</span>
                    <span>{{machine.totalSqueezedFruits | number: '' : this.language}}</span>
                  </td>
                </tr>
                <tr *ngIf="!dataLoaded">
                  <td class="row-height-sm">
                    <p-skeleton height="1em"></p-skeleton>
                  </td>
                  <td class="row-height-sm">
                    <p-skeleton height="1em"></p-skeleton>
                  </td>
                  <td class="row-height-sm">
                    <p-skeleton height="1em"></p-skeleton>
                  </td>
                  <td class="row-height-sm">
                    <p-skeleton height="1em"></p-skeleton>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="summary">
                <div *ngIf="totalTopMachines == 0"
                     class="flex align-items-center justify-content-between">{{'pagination.empty' | transloco}}</div>
                <div *ngIf="totalTopMachines > 0" class="flex align-items-center justify-content-between">
                  {{'pagination.showing' | transloco}} {{first + 1}}
                  {{'pagination.to' | transloco}} {{(first + rows) >= totalTopMachines ? totalTopMachines : (first + rows)}}
                  {{'pagination.of' | transloco}} {{totalTopMachines}}
                  {{(totalTopMachines > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
                </div>
              </ng-template>
            </p-table>
          </ng-container>
          <div *ngIf="!totalSqueezedFruitsGraphData">
            <div class="col-12">
              <p-skeleton width="100%" height="350px"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-export-xls *ngIf="exportVisible"
                [content]="getContentExport()"
                [typeContent]="'MACHINE_ANALYSIS'"
                [exportFileType]="ExportFileType.ANALYSIS_GENERAL"
                [typeExport]="'XLSX'"
                [(visible)]="exportVisible">
</app-export-xls>
